import React from "react";
import { useTranslation } from "react-i18next";

export default function CreateEndpointUsingScripts() {
  const { t } = useTranslation("help");

  return (
    <div className="endpoint-container">
      <a href="#create-endpoint-scripts" className="endpoint-title">
        {t("CreateEndpointUsingScripts.title", "Create Endpoint using Scripts (Python)")}
      </a>

      <pre className="code-block">
        <code>{`import requests
import json

API_KEY = ""  # ${t("CreateEndpointUsingScripts.required", "Required")}
SESSION_KEY = ""  # ${t("CreateEndpointUsingScripts.required", "Required")}
ENDPOINT_NAME = ""  # ${t("CreateEndpointUsingScripts.required", "Required")}
ENDPOINT_TYPE = ""  # ${t("CreateEndpointUsingScripts.required", "Required")} ${t("CreateEndpointUsingScripts.mustbe")}: api_endpoint,
llm_model_endpoint, mcp_endpoint
ENDPOINT_PARAMS = {  # ${t("CreateEndpointUsingScripts.required", "Required")}
    "url": "",  # ${t("CreateEndpointUsingScripts.required", "Required")};  ${t("CreateEndpointUsingScripts.vurl")}
    "selection": "scripts",  # ${t("CreateEndpointUsingScripts.required", "Required")}; ${t("CreateEndpointUsingScripts.mbe")} "scripts"
    "input_script_prompt_processing": ""  # ${t("CreateEndpointUsingScripts.required", "Required")}; ${t("CreateEndpointUsingScripts.mustbeone")}: ${t("CreateEndpointUsingScripts.single1")},
multi
}
ENDPOINT_DESCRIPTION = ""  # ${t("CreateEndpointUsingScripts.optional", "Optional")}

url = f"https://demo.whitehax.com/api/endpoint-config/create/"

payload = {
    "endpoint_name": ENDPOINT_NAME,
    "endpoint_type": ENDPOINT_TYPE,
    "endpoint_params": json.dumps(ENDPOINT_PARAMS),
    "endpoint_desc": ENDPOINT_DESCRIPTION,
}

files = {  # ${t("CreateEndpointUsingScripts.eitherRequired", "Either inputScript or inputScriptFile is required")}
    (
        "inputScript",
        (
            "input_script.py",
            open("input_script.py", "rb"),
            "application/octet-stream",
        ),
    ),
    (
        "outputScript",
        (
            "output_script.py",
            open("output_script.py", "rb"),
            "application/octet-stream",
        ),
    ),
}

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("POST", url, headers=headers, data=payload,
files=files)

print(response.text)`}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 0;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 22px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
        }

        .code-block code {
          font-family: inherit;
        }
      `}</style>
    </div>
  );
}